var handleQuickAddToCart = () => {
  if (handleQuickAddToCart.initialized) return;
  handleQuickAddToCart.initialized = true;

  const closeQuickAdd = (quickaddEl) => {
    quickaddEl.classList.remove("active");
    quickaddEl
      .querySelector(".ProductItem__quickadd__form")
      ?.classList.remove("active");
    quickaddEl
      .querySelector(".ProductItem__quickadd__trigger")
      ?.setAttribute("aria-expanded", "false");
  };

  const mobileDialog = document.getElementById("ProductCardQuickAddModal");
  let mobileOwner = null;

  if (mobileDialog) {
    mobileDialog.addEventListener("close", () => {
      document.documentElement.classList.remove("has-ui-sheet");
      mobileOwner
        ?.querySelector(".ProductItem__quickadd__trigger")
        ?.setAttribute("aria-expanded", "false");
      mobileOwner = null;
    });
    mobileDialog.addEventListener("click", (event) => {
      if (event.target.closest('[data-action="close-sheet"]'))
        mobileDialog.close();
      if (event.target === mobileDialog) {
        const bounds = mobileDialog.getBoundingClientRect();
        if (
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom ||
          event.clientX < bounds.left ||
          event.clientX > bounds.right
        )
          mobileDialog.close();
      }
    });
    mobileDialog.addEventListener("submit", (event) => {
      event.preventDefault();
      const form = event.target;
      const variantId = form.dataset.variantId;
      if (!variantId || !mobileOwner) return;
      addVariantToCart(mobileOwner, variantId, form);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 640 && mobileDialog.open) mobileDialog.close();
    });
  }

  const openMobileQuickAdd = (quickaddEl, trigger) => {
    const template = quickaddEl.querySelector(".ProductCardQuickAdd__mobile");
    if (!mobileDialog || !template) return false;
    const slot = mobileDialog.querySelector(".UiModal__Content");
    slot.replaceChildren(template.content.cloneNode(true));
    const sizes = slot.querySelector(".ProductCardQuickAdd__sizes");
    const choices = quickaddEl.querySelector(".ProductItem__quickadd__list");
    if (sizes && choices) {
      sizes.append(choices.cloneNode(true));
      const label = sizes.querySelector(".ProductItem__quickadd__label");
      if (label) label.textContent = sizes.getAttribute("aria-label");
      sizes.querySelectorAll(".quickadd-variant").forEach((button) => {
        button.setAttribute("aria-pressed", "false");
      });
    }
    mobileOwner = quickaddEl;
    trigger.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("has-ui-sheet");
    mobileDialog.showModal();
    return true;
  };

  const closeOtherQuickAdds = (currentQuickaddEl) => {
    document
      .querySelectorAll(".ProductItem__quickadd.active")
      .forEach((quickaddEl) => {
        if (quickaddEl !== currentQuickaddEl) closeQuickAdd(quickaddEl);
      });
  };

  const updateCartCount = () => {
    const cartCountEl = document.querySelector("span.Cart__Count");
    if (!cartCountEl) return;

    const currentCount =
      parseInt(cartCountEl.textContent.replace(/[^\d]/g, ""), 10) || 0;
    cartCountEl.textContent = `(${currentCount + 1})`;
  };

  const addVariantToCart = async (quickaddEl, variantId, mobileForm = null) => {
    if (!variantId || quickaddEl.classList.contains("is-loading")) return;

    const trigger = quickaddEl.querySelector(".ProductItem__quickadd__trigger");
    quickaddEl.classList.add("is-loading");
    trigger?.setAttribute("aria-busy", "true");
    if (mobileForm) {
      mobileForm.querySelector('[role="alert"]').hidden = true;
      mobileForm.querySelectorAll("button").forEach((button) => {
        button.disabled = true;
      });
      mobileForm.setAttribute("aria-busy", "true");
    }

    if (trigger) trigger.disabled = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: variantId,
              properties: {},
            },
          ],
        }),
      });

      if (!response.ok) throw new Error("Quick add request failed");

      updateCartCount();
      closeQuickAdd(quickaddEl);
      if (mobileForm && mobileDialog.open) mobileDialog.close();

      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            quantity: 1,
          },
        }),
      );
    } catch {
      if (mobileForm) {
        mobileForm.querySelector('[role="alert"]').hidden = false;
      } else {
        const productLink = quickaddEl
          .closest(".ProductItem, .CartProductCard, .CompleteYourSet__Slide")
          ?.querySelector(".ProductItem__Title a, a[href]");
        if (productLink?.href) window.location.assign(productLink.href);
      }
    } finally {
      quickaddEl.classList.remove("is-loading");
      trigger?.removeAttribute("aria-busy");
      if (trigger) trigger.disabled = false;
      if (mobileForm) {
        mobileForm.removeAttribute("aria-busy");
        mobileForm.querySelectorAll("button").forEach((button) => {
          button.disabled =
            button.type === "submit" && !mobileForm.dataset.variantId;
        });
      }
    }
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".ProductItem__quickadd__trigger");
    if (!trigger) return;

    event.preventDefault();
    const quickaddEl = trigger.closest(".ProductItem__quickadd");
    if (!quickaddEl) return;

    if (
      (window.innerWidth <= 640 ||
        (quickaddEl.closest(".CartProductCard") &&
          !trigger.dataset.variantId)) &&
      openMobileQuickAdd(quickaddEl, trigger)
    )
      return;

    const variantId = trigger.getAttribute("data-variant-id");
    if (variantId) {
      addVariantToCart(quickaddEl, variantId);
      return;
    }

    closeOtherQuickAdds(quickaddEl);
    const form = quickaddEl.querySelector(".ProductItem__quickadd__form");
    const shouldOpen = !quickaddEl.classList.contains("active");

    quickaddEl.classList.toggle("active", shouldOpen);
    form?.classList.toggle("active", shouldOpen);
    trigger.setAttribute("aria-expanded", String(shouldOpen));

    if (shouldOpen) {
      const list = form?.querySelector(".ProductItem__quickadd__list");
      if (list) list.scrollLeft = 0;
    }
  });

  document.addEventListener("click", (event) => {
    const variantButton = event.target.closest(".quickadd-variant");
    if (!variantButton) return;

    event.preventDefault();
    const mobileForm = variantButton.closest(".ProductCardQuickAdd__confirm");
    const quickaddEl = mobileForm
      ? mobileOwner
      : variantButton.closest(".ProductItem__quickadd");
    if (!quickaddEl) return;

    if (mobileForm) {
      if (quickaddEl.classList.contains("is-loading")) return;
      mobileForm.dataset.variantId = variantButton.dataset.variantId;
      mobileForm.querySelectorAll(".quickadd-variant").forEach((button) => {
        button.setAttribute("aria-pressed", String(button === variantButton));
      });
      mobileForm.querySelector('[type="submit"]').disabled = false;
      mobileForm.querySelector('[role="alert"]').hidden = true;
      document.dispatchEvent(new CustomEvent("product-card:price-variant", {
        detail: { scope: mobileForm, variantId: variantButton.dataset.variantId },
      }));
      return;
    }
    addVariantToCart(quickaddEl, variantButton.getAttribute("data-variant-id"));
  });

  document.addEventListener("focusin", (event) => {
    const choice = event.target.closest(
      ".ProductItem__quickadd--pill .quickadd-variant",
    );
    const list = choice?.closest(".ProductItem__quickadd__list");
    if (!list) return;

    requestAnimationFrame(() => {
      const choiceBounds = choice.getBoundingClientRect();
      const listBounds = list.getBoundingClientRect();
      const inset = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      if (choiceBounds.left < listBounds.left + inset) {
        list.scrollLeft += choiceBounds.left - listBounds.left - inset;
      } else if (choiceBounds.right > listBounds.right - inset) {
        list.scrollLeft += choiceBounds.right - listBounds.right + inset;
      }
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const quickaddEl = event.target.closest(".ProductItem__quickadd.active");
      if (!quickaddEl) return;

      const trigger = quickaddEl.querySelector(
        ".ProductItem__quickadd__trigger",
      );
      closeQuickAdd(quickaddEl);
      trigger?.focus();
      return;
    }

    if (event.key !== "Enter" && event.key !== " ") return;

    const control = event.target.closest(
      ".ProductItem__quickadd__trigger, .quickadd-variant",
    );
    if (!control || control.tagName === "BUTTON") return;

    event.preventDefault();
    control.click();
  });
};

var handleResizeQuickAddToCart = () => {
  let quickaddEl = document.querySelectorAll(".ProductItem__quickadd");

  if (quickaddEl && window.innerWidth < 992) {
    quickaddEl.forEach((element) => {
      if (element.classList.contains("active")) {
        return;
      }

      let activeForm = element.querySelector(
        ".ProductItem__quickadd__form.active",
      );
      if (activeForm) {
        activeForm.classList.remove("active");
      }

      let activeItem = element.querySelector(".quickadd-variant.active");
      if (activeItem) {
        activeItem.classList.remove("active");
      }
    });
  }
};
